import React from 'react';
import makeStyles from '@material-ui/core/styles/makeStyles';
import Typography from '@material-ui/core/Typography';

const useStyles = makeStyles((theme: any) => ({
  invalidEmail: {
    marginTop: theme.spacing(0.5),
    marginBottom: theme.spacing(0.5),
  },
}));

export default function InvalidEmail() {
  const classes = useStyles();

  return (
    <Typography variant="body2" className={classes.invalidEmail}>
      Please double-check your email.
    </Typography>
  );
}
